import {
  maxLength,
  helpers,
  MessageProps,
  minLength,
  required,
  email,
} from "@vuelidate/validators";
import { ValidationRuleWithParams } from "@vuelidate/core";

type MaxLengthParams = { max: number };

export const n9Required = (field = "Value"): ValidationRuleWithParams => {
  return helpers.withMessage(`${field} is required`, required);
};

export const n9maxLengthWithMsg = (max = 255) => {
  return helpers.withMessage(({ $params }: MessageProps) => {
    const params = $params as MaxLengthParams;
    return `The maximum length allowed is ${params.max} characters`;
  }, maxLength(max));
};

export const n9minLengthWithMsg = (min: number): ValidationRuleWithParams => {
  return helpers.withMessage(
    `The minimum length allowed is ${min} characters`,
    minLength(min)
  );
};

export const n9Email = helpers.withMessage(
  "Enter a valid work email address",
  email
);

export function notPartOf(value: string, context: string): boolean {
  const partRegexp = /[A-Za-z0-9]{4,}/g;
  const contextParts = context.match(partRegexp);
  return !(
    contextParts &&
    contextParts.some(
      (part) =>
        value.toLowerCase().includes(part.toLowerCase()) ||
        part.toLowerCase().includes(value.toLowerCase())
    )
  );
}

export function wordsNotInContext(value: string, context: string): boolean {
  const separator = /[^a-zA-Z]/g;
  const words = value
    .split(separator)
    .map((word) => word.toLowerCase())
    .filter((word) => word !== "");
  const contextWords = context
    .split(separator)
    .map((word) => word.toLowerCase());

  return !words.some((word) =>
    contextWords.some((contextWord) => contextWord.match(word))
  );
}
